import styled from 'styled-components';

import { mediaConfined } from '@xingternal/layout-tokens';
import { spaceXL, spaceXXL } from '@xingternal/tokens';

import { JobPostingModule } from '@/components/job-posting-module';

export const JobPostingDescriptionContainer = styled(JobPostingModule)`
  border-bottom: none;
  padding-bottom: 0;
  @media ${mediaConfined} {
    padding-bottom: ${spaceXL};
  }
`;

export const Descriptionlogo = styled.img`
  display: flex;
  max-width: 100%;
  object-fit: contain;
  margin: 0 auto ${spaceXXL};
`;
